import { Storage } from "@/services/storage-services";
import { ReactNode } from "react";
import { Navigate, useLocation, useSearchParams } from "react-router";

export function RequireAuth({ children }: { children: ReactNode }) {
  const token = Storage.getItem("TreasuraAdminUserToken");

  const location = useLocation();
  // console.log(location);
  if (!token) {
    return <Navigate to="/" state={{ from: location }} replace />;
  } else {
    return children;
  }
}


export function RoleCheck({
  children,
  role,
}: {
  children: ReactNode;
  role: boolean;
}) {

  const location = useLocation();
  console.log(location);
  if (role !== true) {
    return <Navigate to="/dashboard" state={{ from: location }} replace />;
  } else {
    return children;
  }
}
